export enum PropertyCatalogItemsMoveTo {
    CATALOG = 'catalog',
    ORDER = 'order',
    INVENTORY = 'inventory',
    CUSTOM_LIST = 'custom-list',
}
